import { createGlobalStyle } from "styled-components"
import reset from "styled-reset"

export const GlobalStyle = createGlobalStyle`
  ${reset}
  h1,h2,h3,h4,h5,h6{
    font-family: arboria, sans-serif;
    font-weight: 700;
  }
  h1 {
    font-size: 40px;
  }
  
  h2 {
    font-size: 35px;
  }
  
  h3 {
    font-size: 30px;
  }
  
  h4 {
    font-size: 25px;
  }
  
  h5 {
    font-size: 20px;
  }
  
  h6 {
    font-size: 18px;
  }
  h1,h2,h3,h4,h5,h6{
    font-weight: 500;
  }
  html{
    font-family: arboria, sans-serif;
  }
  p,span,button,a{
    font-weight: 300;
    font-size: 17px;
  }
  p{
    line-height: 1.2;
  }
  strong{
    font-weight: 500;
  }
`
export const theme = {
  colors: {
    darkBlue: "#00416A",
    mutedBlue: "#017CBA",
    lightBlue: "#79ADD3",
    brightBlue: "#00AEEF",
    white: "#FFFFFF",
    grey: "#979797",
  },
}
